
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningRainShowersPolartwilightColour as ObiLightningRainShowersPolartwilightColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-rain-showers-polartwilight-colour.js';
 
 
 

 
 export const ObiLightningRainShowersPolartwilightColour = createComponent({
   react: React,
   tagName: 'obi-lightning-rain-showers-polartwilight-colour',
   elementClass: ObiLightningRainShowersPolartwilightColourElement,
   events: {
     
   }
  });
 
 